<template>
  <div class="inbox-alert-main">
    <!-- 拒绝弹窗 -->
    <transition name="alert">
      <div class="no" v-if="alertData.show && alertData.type === 'inboxNo'">
        <i class="close iconfont iconx" @click="close"></i>
        <div class="title">请选择您拒绝的原因</div>
        <textarea class="text" v-model="reason" placeholder="请输入您拒绝的原因......"></textarea>
        <div class="list">
          <div
            v-for="(item, index) in menu"
            :key="index"
            :class="['item', menuAction.indexOf(item) !== -1 ? 'action' : '']"
            @click="selectMenu(item)">
            {{item}}
          </div>
        </div>
        <button :class="['submit', isSubmit ? 'action' : '']" @click="submit">确定</button>
      </div>
    </transition>
  </div>
</template>
<script>
const menu = [
  '对公司不感兴趣',
  '对职位不感兴趣',
  '暂不看机会'
];
import {mapState} from 'vuex';
export default {
  name: 'inboxAlert',
  data() {
    return {
      menu,
      menuAction: [],
      reason: '',
      isSubmit: false
    };
  },
  computed: {
    ...mapState('me', ['isLogin']),
    ...mapState('app', ['alertData'])
  },
  watch: {
    reason(value) {
      if (value) {
        this.isSubmit = true;
      } else {
        this.isSubmit = false;
      }
    },
    'alertData': {
      keep: true,
      immediate: true,
      handler: function (alertData) {
        if (!alertData.show) {
          document.body.style.position = 'initial'
          document.body.style.overflow = 'initial'
        }else{
          document.body.style.position = 'static'
          document.body.style.overflow = 'hidden'
        }
      }
    }
  },
  methods: {
    close() {
      this.$store.dispatch('app/setAlertDataShow', false);
    },
    submit() {
      if (!this.isSubmit) {
        return false;
      }
      let data = {
        reason: this.reason
      };
      this.reason = '';
      this.menuAction = [];
      this.alertData.confirm && this.alertData.confirm(data);
      this.$store.dispatch('app/setAlertDataShow', false);
    },
    selectMenu(text) {
      let index = this.menuAction.indexOf(text);
      let menuAction = this.menuAction;
      let reason = this.reason;
      if (index === -1) {
        menuAction.push(text);
        reason = reason + (reason ? ' ' : '') + text;
      } else {
        menuAction.splice(index, 1);
        reason = reason.replace(text, '')
      }
      this.menuAction = menuAction;
      this.reason = reason.trim();
    }
  }
}
</script>
<style lang="scss" scoped>
  .close {
    font-size: 22px;
    color: #404040;
    position: absolute;
    top: 31px;
    right: 32px;
    cursor: pointer;
    font-weight: 600;
  }
  .cover {
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, .5);
    position: fixed;
    top: 0;
    left: 0;
  }
  .inbox-alert-main {
    // font-family:PingFangSC-Medium,PingFang SC;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 0;
    height: 0;
    &>div {
      position: relative;
    }
    .no {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: 480px;
      height: fit-content;
      background: #fff;
      border-radius: 4px;
      color: #404040;
      padding: 32px 32px 30px;
      box-sizing: border-box;
      overflow: hidden; // bfc
      .title {
        font-size: 18px;
        color: #404040;
      }
      .text {
        width: 100%;
        height: 82px;
        background: #F9F9F9;
        padding: 10px 18px;
        box-sizing: border-box;
        margin-top: 30px;
        outline: none;
        font-size: 14px;
        border: none;
        line-height: 20px;
        color: #606060;
        font-family:'PingFangSC-Regular,PingFang SC';
      }
      .list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        margin-top: 22px;
        .item {
          height: 34px;
          line-height: 34px;
          color: #606060;
          font-size: 14px;
          border: 1px solid #DEDFE1;
          border-radius: 2px;
          margin-right: 16px;
          margin-bottom: 12px;
          padding: 0 18px;
          cursor: pointer;
          &.action {
            color: #FF4F4C;
            border-color: #FF4F4C;
          }
        }
      }
      .submit {
        width: 102px;
        height: 36px;
        font-size: 14px;
        color: #fff;
        letter-spacing:1px;
        border-radius: 2px;
        background: #C4C4C4;
        margin-top: 12px;
        float: right;
        &.action {
          background: #FF4F4C;
          border-color: #FF4F4C;
          color: #fff;
        }
      }
    }
  }
</style>
